import { api } from '../core';
import {
  BUNDLE_SECTIONS_SUGGESTIONS_CATEGORY_LIST_TAG,
  BUNDLE_SECTIONS_SUGGESTIONS_SUB_CATEGORY_LIST_TAG
} from '../constants';
import {
  RootState,
  setBundleSectionsSuggestionsCategoryList,
  setBundleSectionsSuggestionsSubCategoryList
} from '@/store';

interface Category {
  categoryId: string;
  categoryName: string;
}

type BundleSectionsSuggestionsResponse = Category[];

type GetBundleSectionsSuggestionsProps = {
  bundleId: string;
  abortController?: AbortController;
};

const getBundleSectionsSuggestionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBundleSectionsSuggestionsCategoryList: builder.query<
      BundleSectionsSuggestionsResponse,
      GetBundleSectionsSuggestionsProps
    >({
      query: ({ abortController = new AbortController() }: GetBundleSectionsSuggestionsProps) => ({
        url: `category/list`,
        method: 'GET',
        signal: abortController.signal
      }),
      providesTags: (_result, _err, { bundleId }) => [
        { type: BUNDLE_SECTIONS_SUGGESTIONS_CATEGORY_LIST_TAG, id: bundleId }
      ],
      async onQueryStarted(_arg, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          const state = getState() as RootState;

          if (data && Array.isArray(data) && state.sharedData.activeBundleType) {
            dispatch(
              setBundleSectionsSuggestionsCategoryList({
                key: state.sharedData.activeBundleType,
                data: data.map((item) => ({
                  id: item.categoryId,
                  name: item.categoryName
                }))
              })
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getBundleSectionsSuggestionsCategoryList in onQueryStarted:', error);
          }
        }
      }
    }),
    getBundleSectionsSuggestionsSubCategoryList: builder.query<
      BundleSectionsSuggestionsResponse,
      GetBundleSectionsSuggestionsProps
    >({
      query: ({ abortController = new AbortController() }: GetBundleSectionsSuggestionsProps) => ({
        url: `sub-category/list`,
        method: 'GET',
        signal: abortController.signal
      }),
      providesTags: (_result, _err, { bundleId }) => [
        {
          type: BUNDLE_SECTIONS_SUGGESTIONS_SUB_CATEGORY_LIST_TAG,
          id: bundleId
        }
      ],
      async onQueryStarted(_arg, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          const state = getState() as RootState;

          if (data && Array.isArray(data) && state.sharedData.activeBundleType) {
            dispatch(
              setBundleSectionsSuggestionsSubCategoryList({
                key: state.sharedData.activeBundleType,
                data: data.map((item) => ({
                  id: item.categoryId,
                  name: item.categoryName
                }))
              })
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getBundleSectionsSuggestionsSubCategoryList in onQueryStarted:', error);
          }
        }
      }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const {
  useLazyGetBundleSectionsSuggestionsCategoryListQuery,
  useLazyGetBundleSectionsSuggestionsSubCategoryListQuery
} = getBundleSectionsSuggestionsApi;
